<template>
  <div class="personal-message p-10">
    <div class="ly-card search-content">
      <div class="btn-group">
        <el-button type="primary" size="medium" @click="readAll">全部已读</el-button>
      </div>
      <div class="search-group">
        <el-input placeholder="标题关键词" v-model.trim="searchFormData.query" />
        <el-button type="primary" size="medium" @click="search">查询</el-button>
      </div>
    </div>
    <div class="ly-card">
      <ly-table :getTableData="getTableData" :tableHeader="tableHeader" :searchFormData="searchFormData" ref="lyTable">
        <template v-slot:title="row">
          <el-button size="mini" type="text" @click="detail(row)">{{ row.title }}</el-button>
        </template>
        <template v-slot:action="row">
          <el-button @click="del(row)" v-if="row.send_user_id !== -1" type="text" class="el-button--danger" size="mini">删除</el-button>
        </template>
      </ly-table>
    </div>
    <el-dialog :visible.sync="dg" title="消息详情">
      <div class="personal-message-dg">
        <div>
          <span class="title">公告标题</span>
          <span>{{ curItem.title }}</span>
        </div>
        <div>
          <span class="title">公告内容</span>
          <span v-html="curItem.content"></span>
        </div>
        <div>
          <span class="title">提醒方式</span>
          <span>{{ curItem.is_notify_popup_label }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Dialog, Input } from 'element-ui';
import { sys } from '@/api';
import LyTable from '@/components/LyTable';
import { perMessageTable } from '@/utils/tableHeader';

export default {
  name: 'PersonalMessage',
  components: {
    ElDialog: Dialog,
    LyTable,
    ElInput: Input
  },
  data() {
    return {
      dg: false,
      searchFormData: {
        receive_user_id: '',
        query: ''
      },
      curItem: {},
      tableHeader: perMessageTable,
      getTableData: sys.getSysMsg
    };
  },
  async mounted() {
    if (!this.user.info.username) {
      await this.$store.dispatch('user/addUser');
    }
    this.searchFormData.receive_user_id = this.user.info.id;
    this.init();
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    async init() {
      this.search();
      // 获取多媒体信息地址
      this.baseUrl = await this.$store.dispatch('app/getOssUrl');
    },
    search() {
      this.$refs.lyTable.setData();
    },
    detail(row) {
      this.curItem = row;
      this.dg = true;
    },
    del(row) {
      this.$confirm('永久删除该条信息, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          sys
            .delSysMsg({
              msg_id: row.id,
              methold: 'post'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    readAll() {
      sys.readAllMsg().then(res => {
        if (res) {
          this.$message.success(res.msg || '全部已读！');
          this.search();
        }
      });
    }
  }
};
</script>

<style lang="less">
.personal-message {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .field-label .el-checkbox {
    min-width: 100px;
    margin-bottom: 15px;
  }
}
.personal-message-dg {
  > div {
    display: flex;
    margin: 15px 0;
    .title {
      width: 120px;
    }
  }
}
</style>
